export default "__VITE_ASSET__CISF9gYY__"